/**
 * Eye life: blinks and micro-saccades. Behaviour only; outputs an `openness`
 * (1 open, 0 closed) and a small gaze jitter the body adds to its look-at.
 *
 * Blinks close fast and open slower (like the real thing), come on a random
 * timer with occasional double blinks, and are also triggered by fast head
 * turns — eyes blink on big gaze shifts.
 */
export class EyeLife {
  openness = 1;
  /** micro-saccade offsets (rad) added on top of the gaze target */
  saccadeYaw = 0;
  saccadePitch = 0;

  private t = 0;
  private nextBlink = 2.5;
  private blinkUntil = -1;
  private lastBlink = -10;
  private nextSaccade = 0.8;

  private blink(): void {
    this.blinkUntil = this.t + 0.09;
    this.lastBlink = this.t;
  }

  /** @param headAngularSpeed rad/s of the head, for turn-triggered blinks */
  update(dt: number, headAngularSpeed: number): void {
    this.t += dt;

    if (this.t > this.nextBlink) {
      this.blink();
      this.nextBlink = Math.random() < 0.2 ? this.t + 0.45 : this.t + 2 + Math.random() * 5;
    } else if (headAngularSpeed > 2.5 && this.t - this.lastBlink > 1.2) {
      this.blink();
    }

    const target = this.t < this.blinkUntil ? 0 : 1;
    const rate = target < this.openness ? 40 : 14;
    this.openness += (target - this.openness) * (1 - Math.exp(-rate * dt));

    if (this.t > this.nextSaccade) {
      // saccades are effectively instantaneous; the body eases them slightly
      this.saccadeYaw = (Math.random() - 0.5) * 0.12;
      this.saccadePitch = (Math.random() - 0.5) * 0.08;
      this.nextSaccade = this.t + 0.3 + Math.random() * 1.8;
    }
  }
}
